import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import {
  TitleSkillSuggestionRes,
} from "../../types/api-response";
import { callFromMiddleware } from "../../utils";
import { TitleSkillSuggestionPayload } from "../../types/api-payload";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});

export const jpmsApi = createApi({
  reducerPath: "jpms",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  endpoints: (builder) => ({
    getTitleSkillSuggestion: builder.query<
      TitleSkillSuggestionRes[],
      TitleSkillSuggestionPayload
    >({
      query: (args) => {
        const sanitizedKeyWord = args?.keyWord?.replace(/\//g, ' ');
        return {
          url: `${callFromMiddleware(ENDPOINTS.getTitleSkillSuggestion)}/${
            sanitizedKeyWord
          }?type=${args.type}`,
          method: "GET",
          headers: API_HEADERS,
        }
      },
    }),
    getJobPostedList: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.getJobPostList)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getAiDescription: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.getAiDescription)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getAiSkills: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.getAiSkills)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getPerkBenifits: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.getPerkBenifits)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    keyWordsAutoLookUp: builder.query<any, any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.keyWordsAutoLookUp)}/${
          args.keyWords
        }`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    getCorpInfo: builder.query<any, any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getCorpInfo)}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    jobPostForm: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.jobPost)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getJobPostCopy: builder.query<any, any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getJobPostCopy)}/${args}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    getJobPostEdit: builder.query<any, any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getJobPostEdit)}/${args}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    jobPostUpdate: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.jobUpdate)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    aiFeedBack: builder.query<any, any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.aiFeedBack)}`,
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    trackHealth : builder.query<any, any>({
      query: (body) => ({
        url: callFromMiddleware(ENDPOINTS.healthTracker),
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getAllFolders : builder.query<any, any>({
      query: (body) => ({
        url: callFromMiddleware(ENDPOINTS.getAllFolders),
        method: "GET",
        headers: API_HEADERS,
        body:body
      }),
    }),
  }),
});

export const {
  useLazyGetTitleSkillSuggestionQuery,
  useGetJobPostedListQuery,
  useLazyGetJobPostedListQuery,
  useLazyGetAiDescriptionQuery,
  useLazyGetAiSkillsQuery,
  useGetPerkBenifitsQuery,
  useLazyKeyWordsAutoLookUpQuery,
  useGetCorpInfoQuery,
  useLazyJobPostFormQuery,
  useLazyGetJobPostCopyQuery,
  useLazyGetJobPostEditQuery,
  useLazyJobPostUpdateQuery,
  useLazyAiFeedBackQuery,
  useLazyTrackHealthQuery,
  useLazyGetAllFoldersQuery
  
} = jpmsApi;

export default jpmsApi;
